// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-toolbar input[type=\"radio\"] {\n  opacity: 0;\n  position: fixed;\n  width: 0; }\n\n.radio-toolbar label {\n  display: inline-block;\n  background-color: #f2f2f2;\n  cursor: pointer;\n  padding: 5px 10px;\n  font-family: sans-serif, Arial;\n  font-size: 14px;\n  border-radius: 4px; }\n\n.radio-toolbar input[type=\"radio\"]:checked + label {\n  background-color: #7A6FBE;\n  border: none;\n  color: #ffffff; }\n\n#radio-title {\n  margin-bottom: 5px; }\n", ""]);
// Exports
module.exports = exports;
